import { BaseModalProps, Modal } from 'components/core-v2'
import React from 'react'

interface ModalTemplateBaseProps {
  body: any
  header: any
  isLoading?: boolean
}

export type ModalTemplateProps = BaseModalProps & ModalTemplateBaseProps

export const ModalTemplate = ({ body, header, isLoading, isOpen, onClose }: ModalTemplateProps) =>
  isLoading ? (
    <>Loading</>
  ) : (
    <Modal.Wrapper
      aria-labelledby="assets-modal-label"
      isOpen={isOpen}
      width="lg"
      onClose={onClose}
    >
      <Modal.Header id="assets-modal-label" onClose={onClose}>
        <h2>{header}</h2>
      </Modal.Header>
      <Modal.Body className="mb-4">{body}</Modal.Body>
    </Modal.Wrapper>
  )
